import { useCallback } from "react";
import ReactGA from "react-ga4";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Dialog } from "@material-ui/core";

import "./campaign.scss";
import CustomButton from "../../../uiKit/Button/CustomButton";
import { useStylesDialog } from "../../../uiKit/CustomDialog/customDialog";
import CampaignThankYou from "./thankYou";

import Checkout from "../../Checkout/checkout";
import CampaignCheckout from "../../Checkout/campaignCheckout";
import DonationForm from "../../Checkout/donationForm";

import {
  setDonationFormOpen,
  setStripeOpen,
  setCampaignThankOpen,
} from "../../../redux/state/donationSlice";
import { useParams } from "react-router-dom";
import { getCampaignDonations } from "../../../redux/state/campaignSlice";
import { getCampaignBalanceDetails } from "../../../redux/state/paymentSlice";
import AutoDonateContent from "../../PersonalSettings/PaymentPreferences/autoDonate";

const DonationAmount = () => {
  const dispatch = useDispatch();
  const dialogClasses = useStylesDialog();
  const { campaignId, communityId } = useParams();

  const openStripe = useSelector((state) => state.donation.stripeOpen, shallowEqual);
  const open = useSelector((state) => state.donation.donationFormOpen, shallowEqual);
  const campaignThankOpen = useSelector((state) => state.donation.campaignThankOpen, shallowEqual);
  const autoDonateOpen = useSelector((state) => state.donation.autoDonateOpen, shallowEqual);
  const target = useSelector((state) => state.campaign.campaign?.amount, shallowEqual);

  const donateHandler = useCallback(() => {
    ReactGA.event("donate_campaign_start");
    dispatch(setDonationFormOpen(true));
  }, [dispatch]);

  const closeStripeHandler = () => dispatch(setStripeOpen(false));
  const closeFormHandler = () => dispatch(setDonationFormOpen(false));
  const closeCampaignThankHandler = () => {
    setTimeout(() => {
      if (!communityId || !campaignId || !target) return;
      dispatch(getCampaignBalanceDetails({ communityId, campaignId, target }));
      dispatch(
        getCampaignDonations({
          communityId,
          campaignId,
          page: 1,
          pageSize: 8,
        })
      );
    }, 2000);
    dispatch(setCampaignThankOpen(false));
  };

  return (
    <>
      <CustomButton title="Donate" onClick={donateHandler} />
      <Dialog
        open={open}
        onClose={closeFormHandler}
        disableScrollLock={true}
        classes={dialogClasses}
      >
        <DonationForm />
      </Dialog>

      <Dialog
        open={openStripe}
        onClose={closeStripeHandler}
        disableScrollLock={true}
        classes={dialogClasses}
      >
        <Checkout Component={CampaignCheckout} type={0} />
      </Dialog>
      <Dialog
        open={campaignThankOpen}
        onClose={closeCampaignThankHandler}
        disableScrollLock={true}
        classes={dialogClasses}
      >
        <CampaignThankYou onClose={closeCampaignThankHandler} />
      </Dialog>
      <Dialog
        open={autoDonateOpen}
        onClose={closeCampaignThankHandler}
        disableScrollLock={true}
        classes={dialogClasses}
      >
        <AutoDonateContent onClose={closeCampaignThankHandler} />
      </Dialog>
    </>
  );
};

export default DonationAmount;
